import { Component, ViewChild } from '@angular/core'
import { Observable } from 'rxjs'
import { EbFormComponent } from '../../../../../form/components/form/eb-form.component'
import { EbFormConfig } from '../../../../../form/interfaces/eb-form.interface'
import { EbUpdateProfileFormConfigService } from '../../services/facades/eb-update-profile-form-config.service'

@Component({
    selector: 'eb-update-profile-form',
    templateUrl: './eb-update-profile-form.component.html',
    styleUrls: ['./eb-update-profile-form.component.scss'],
    standalone: false
})
export class EbUpdateProfileFormComponent {
  @ViewChild('formComponent') formComponent: EbFormComponent

  formConfig$: Observable<EbFormConfig>

  constructor(configService: EbUpdateProfileFormConfigService) {
    this.formConfig$ = configService.formConfig$
  }
}
